import { render, staticRenderFns } from "./expressOrderTemp.vue?vue&type=template&id=05c58aaf&scoped=true&"
import script from "./expressOrderTemp.vue?vue&type=script&lang=js&"
export * from "./expressOrderTemp.vue?vue&type=script&lang=js&"
import style0 from "./expressOrderTemp.vue?vue&type=style&index=0&id=05c58aaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c58aaf",
  null
  
)

component.options.__file = "expressOrderTemp.vue"
export default component.exports